const config = [
  {
    header: 'Housing Costs',
    trackingFieldName: 'housing_open',
    className: 'colHousing',
    headerValue: 'compareData.housingPercentDifference',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [
          { text: '' },
          { key: 'citiesData.sourceCityState' },
          { key: 'citiesData.destinationCityState' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Median 2-bedroom apartment rent' },
          { key: 'citiesData.sourceCity.apt_rent_cost', type: 'currency' },
          { key: 'citiesData.destinationCity.apt_rent_cost', type: 'currency' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Median home price (3BR, 2BA)' },
          { key: 'citiesData.sourceCity.home_cost', type: 'currency' },
          { key: 'citiesData.destinationCity.home_cost', type: 'currency' },
        ],
      },
      {
        type: 'disclaimer',
        disclaimerText:
          "Do these housing costs seem low to you? That's probably because we're measuring average costs for the larger metro area, not just the city limits.",
      },
    ],
  },
  {
    header: 'Transportation Costs',
    trackingFieldName: 'transportation_open',
    className: 'colTransportation',
    headerValue: 'compareData.transportationPercentDifference',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [
          { text: '' },
          { key: 'citiesData.sourceCityState' },
          { key: 'citiesData.destinationCityState' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Gas (per gallon)' },
          {
            key: 'citiesData.sourceCity.gas_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
          {
            key: 'citiesData.destinationCity.gas_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
    ],
  },
  {
    header: 'Food Costs',
    trackingFieldName: 'food_open',
    className: 'colFood',
    headerValue: 'compareData.foodPercentDifference',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [
          { text: '' },
          { key: 'citiesData.sourceCityState' },
          { key: 'citiesData.destinationCityState' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Bread' },
          {
            key: 'citiesData.sourceCity.bread_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
          {
            key: 'citiesData.destinationCity.bread_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Dozen eggs' },
          {
            key: 'citiesData.sourceCity.eggs_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
          {
            key: 'citiesData.destinationCity.eggs_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Gallon of milk' },
          {
            key: 'citiesData.sourceCity.milk_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
          {
            key: 'citiesData.destinationCity.milk_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: '12-inch Pizza Hut pizza' },
          {
            key: 'citiesData.sourceCity.pizza_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
          {
            key: 'citiesData.destinationCity.pizza_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'McDonalds Quarter-Pounder with cheese' },
          {
            key: 'citiesData.sourceCity.quarter_pounder_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
          {
            key: 'citiesData.destinationCity.quarter_pounder_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
    ],
  },
  {
    header: 'Entertainment Costs',
    trackingFieldName: 'entertainment_open',
    className: 'colEntertainment',
    headerValue: 'compareData.entertainmentPercentDifference',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [
          { text: '' },
          { key: 'citiesData.sourceCityState' },
          { key: 'citiesData.destinationCityState' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Movie ticket' },
          {
            key: 'citiesData.sourceCity.movie_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
          {
            key: 'citiesData.destinationCity.movie_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Yoga class' },
          {
            key: 'citiesData.sourceCity.yoga_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
          {
            key: 'citiesData.destinationCity.yoga_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: '6-pack Heineken beer' },
          {
            key: 'citiesData.sourceCity.heineken_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
          {
            key: 'citiesData.destinationCity.heineken_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
    ],
  },
  {
    header: 'Healthcare Costs',
    trackingFieldName: 'healthcare_open',
    className: 'colHealthcare',
    headerValue: 'compareData.healthcarePercentDifference',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [
          { text: '' },
          { key: 'citiesData.sourceCityState' },
          { key: 'citiesData.destinationCityState' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: "Cost of a doctor's visit" },
          {
            key: 'citiesData.sourceCity.doctor_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
          {
            key: 'citiesData.destinationCity.doctor_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Cost of a dentist visit' },
          {
            key: 'citiesData.sourceCity.dentist_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
          {
            key: 'citiesData.destinationCity.dentist_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Cost of a optometrist visit' },
          {
            key: 'citiesData.sourceCity.optometrist_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
          {
            key: 'citiesData.destinationCity.optometrist_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Cost of lipitor' },
          {
            key: 'citiesData.sourceCity.lipitor_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
          {
            key: 'citiesData.destinationCity.lipitor_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
    ],
  },
  {
    header: 'School Comparison',
    trackingFieldName: 'school_open',
    className: 'colSchool',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [
          { text: '' },
          { key: 'citiesData.sourceCityState' },
          { key: 'citiesData.destinationCityState' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Average public school rating on GreatSchools.com' },
          { key: 'citiesData.sourceCity.greatschools_rating' },
          { key: 'citiesData.destinationCity.greatschools_rating' },
        ],
      },
    ],
    isVisible(data) {
      return data.showSchool;
    },
  },
];
export default config;
